export interface PresaleCode {
  id: number;
  code: string | null;
  code_type: 'shared' | 'per_user' | 'tba';
  label: string;
  instructions: string | null;
  source: string;
  upvote_count: number;
  viewer_has_upvoted: boolean;
}

export interface Presale {
  id: number;
  event: { id: number };
  status: string;
  codes: PresaleCode[];
}

export interface PresaleSubmission {
  code: string;
  label: string;
  instructions: string;
}

export function validatePresaleSubmission(input: PresaleSubmission): string | null {
  const bytes = (value: string) => new TextEncoder().encode(value).length;
  if (!input.code.trim()) return 'Enter a code.';
  if (bytes(input.code.trim()) > 100) return 'Code must be at most 100 UTF-8 bytes.';
  if (bytes(input.label) > 100) return 'Label must be at most 100 UTF-8 bytes.';
  return null;
}
